// BestSellerApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'BestSeller'];

// Enhance the base API service by adding entication-related tag types
const BestSellerApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
        
      // Fetch BestSeller query (GET request to /me)
      getBestSeller: build.query({
        query: () => ({
          url: `/Grid`,
        }),
        providesTags: ['BestSeller'],
      }),  
      
       
    }),
    overrideExisting: false,
  });

export default BestSellerApi;

// Exporting hooks for each endpoint to be used in components
export const {
     useGetBestSellerQuery,
 } = BestSellerApi;


